import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import React, { useContext, useState, useCallback } from 'react';
import messages from '../messages';
import { FormattedMessage } from 'react-intl';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import AddMarketplaceRule from './add-marketplace-rule';
import AddTagRule from './add-tag-rule';
import AddAgeRule from './add-age-rule';
import { AllocationRulesContext } from '../context';
import { FILTERSET_EDITOR_TYPE_ALLOCATION_RULE } from '../../../../../components/filter-editor/constants/filterset-editor-type';

import FilterEditorModal from '../../../../../components/filter-editor/modal';

import style from '../style.module.less';

const AddRuleButton = () => {
  const { allocationRules, onAddNewCustomAllocationRule } = useContext(AllocationRulesContext);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = useCallback(() => {
    setIsModalOpen(true);
  }, [setIsModalOpen]);

  const closeModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  return (
    <div className={style['rule-wrapper']}>
      <div />
      <div>
        <DropdownMenu className={style['add-rule-wrapper']}>
          <DropdownMenuToggler className={style['add-rule-button']} hideChevron theme='unstyled'>
            <FontAwesomeIcon className={style['add-rule-icon']} icon={faPlus} />
            {allocationRules.length === 0 && <FormattedMessage {...messages.noRulesCreated} />}
            {allocationRules.length > 0 && <FormattedMessage {...messages.allocationStrategiesAddRule} />}
          </DropdownMenuToggler>
          <AddMarketplaceRule />
          <AddTagRule />
          <AddAgeRule />
          <DropdownMenuItem onClick={openModal}>
            <FormattedMessage {...messages.allocationStrategiesAddAdvancedRule} />
          </DropdownMenuItem>
        </DropdownMenu>
        {isModalOpen && (
          <FilterEditorModal
            filtersetEditorType={FILTERSET_EDITOR_TYPE_ALLOCATION_RULE}
            onAddNewCustomAllocationRule={onAddNewCustomAllocationRule}
            onClose={closeModal}
          />
        )}
      </div>
    </div>
  );
};

export default AddRuleButton;
